import { AxiosResponse } from "axios";
import illusWaiting from "images/illus_waiting.svg";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "services/http-common";

const Waiting: React.FunctionComponent<{}> = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();
  const zpr = searchParams.get("zpr");
  const fid = searchParams.get("fid");
  const handleOpenMiniapp = (activeTab: number | 1) => {
    window.location.href = `https://zalo.me/s/3251370535821692872?active=${activeTab}`;
  };
  useEffect(() => {
    api
      .post<AxiosResponse<any>>(`/payment/check`, {
        zpr,
      })
      .then((resp) => {
        setIsLoading(false);
        if (resp.status != 200) {
          navigate(`/lp?fid=${fid}`);
        }
      })
      .catch((e) => {
        navigate(`/lp?fid=${fid}`);
      });
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      <div className="pt-12 px-10 flex flex-col items-center gap-4">
        <img className="w-32 h-32" src={illusWaiting} alt="" />
        <div className="font-medium text-center text-[22px] leading-[26px]">
          Quảng bá bài đăng đang được xử lý
        </div>
        <div className="font-light text-center text-[15px] leading-[20px]">
          Bạn có thể kiểm tra trạng thái ở trang quản lý bài đăng
        </div>
        <div
          className="mt-10 py-3 px-6 flex items-center justify-center bg-blue-600 text-white w-full rounded-[100px] font-medium text-[15px] leading-[20px]"
          onClick={() => handleOpenMiniapp(1)}
        >
          Quản lý bài đăng
        </div>
        <div
          className="mt-1 py-3 px-6 flex items-center justify-center bg-blue-200 text-blue-600 w-full rounded-[100px] font-medium text-[15px] leading-[20px]"
          onClick={() => handleOpenMiniapp(0)}
        >
          Xem báo cáo
        </div>
      </div>
    </>
  );
};

export default Waiting;
